import amandaData from "./amandaBaroni"
import biraData from "./biraCarvalho"
import daviData from "./daviMarcos"
import douglasData from "./douglasLopes"
import jonesData from "./jones"
import kamilaData from "./kamilaCamillo"
import kanandaData from "./kanandaFerreira"
import rosanaData from "./rosanaRodrigues"


const artists = [
    {
        id: 0,
        nome: 'Amanda Baroni',
        socialMedia: 'amandabaroni_',
        avatar: amandaData.avatar,
        presentation: 'Amanda Baroni é fotógrafa formada pela Escola de Fotógrafos Populares e integrante do Imagens do Povo desde 2012. Sua pesquisa individual desde o princípio foi trabalhar distintos campos culturais a partir da fotografia, especialmente na relação entre os produtores culturais e o território que habitam, no caso, as favelas do Rio. E, seja por ação do Estado, seja por veiculação midiática, as favelas têm sido associadas a uma série de problemas sociais, tais como a justificativa para a violência na cidade. Tal percepção gera uma cultura do medo relativa aos indivíduos que lá vivem, massificando uma visão pejorativa e duvidosa da comunidade, de seus hábitos e da estética produzida nesses lugares. Em paralelo, pretende-se utilizar os elementos da natureza na composição dos cenários fotografados, pois tanto o fogo, como a água, a terra e o ar podem se manifestar em forma de solução básica para a vida, como podem também, em função das circunstâncias, serem associados a agentes da morte, da mesma maneira que as favelas. Pretende-se, assim, desmistificar o que é favela por meio do olhar de uma artista da Maré, que também reconstruiu sua visão sobre o próprio território através da fotografia, de modo a valorizar uma estética periférica carregada de positividade, focalizando os talentos locais e transformando-os em personagens folclóricos urbanos, visando a criação de uma nova perspectiva e de novas (ver)dades.',
        audioPresentation: amandaData.audio,
        photographies: [
            {
                name: 'Elemento Fogo - Ágatha - Parque União, Maré 1',
                photo: amandaData.amanda07
            }, 
            {
                name: 'Elemento Fogo - Ágatha - Parque União, Maré 2',
                photo: amandaData.amanda04
            },
            {
                name: 'Elemento Fogo - Ágatha - Parque União, Maré 3.',
                photo: amandaData.amanda11
            },
            {
                name: 'Elemento Ar - Hugo Oliveira - Morro da Providência 1.',
                photo: amandaData.amanda08
            },
            {
                name: 'Elemento Ar - Hugo Oliveira - Morro da Providência 2.',
                photo: amandaData.amanda12
            },
            {
                name: 'Elemento Água - Khalifa - Nova Holanda, Maré.',
                photo: amandaData.amanda03
            },
            {
                name: 'Elemento Água - Thammy DB - Nova Holanda, Maré 1.',
                photo: amandaData.amanda05
            },
            {
                name: 'Elemento Água - Thammy DB - Nova Holanda, Maré 2. ',
                photo: amandaData.amanda06
            },
            {
                name: 'Elemento Terra - Luana Laura - Mangueirinha, Caxias 1.',
                photo: amandaData.amanda01
            },
            {
                name: 'Elemento Terra - Luana Laura - Mangueirinha, Caxias 2. ',
                photo: amandaData.amanda09
            },
            {
                name: 'Elemento Terra - Luana Laura - Mangueirinha, Caxias 3.',
                photo: amandaData.amanda02
            },
            {
                name: 'BBoy Angelo- Parque União, Maré',
                photo: amandaData.amanda10
            },


        ]
    },
    {
        id: 1,
        nome: 'Bira Carvalho',
        socialMedia: 'bira_carvalho_',
        avatar: biraData.avatar,
        presentation: 'Meu nome é Ubirajara Zeferino de Carvalho, sou morador do Complexo da Maré (Favela Nova Holanda) - RJ, desde 1975, quando cheguei aos 5 anos de idade. Minha entrada na fotografia foi no ano de 2000 em curso básico no CEASM; em 2004, entro para a Escola de Fotógrafos Populares, um curso idealizado pelo Fotógrafo João Roberto Ripper realizado na ONG Observatório de Favelas; em 2015, assumo a coordenação do projeto Imagens Do Povo, ficando até dezembro de 2020; e desde 2018 faço curadoria da Revista Periferias, no Instituto Maria e João Aleixo (IMJA).',
        audioPresentation: biraData.audio,
        photographies: [
            {
                name: '',
                photo: biraData.bira01
            },
            {
                name: '',
                photo: biraData.bira02
            },
            {
                name: '',
                photo: biraData.bira03
            },
            {
                name: '',
                photo: biraData.bira04
            },
            {
                name: '',
                photo: biraData.bira05
            }
        ]
    },
    {
        id: 2,
        nome: 'Davi Marcos',
        socialMedia: 'davi.marcos.zorro',
        avatar: daviData.avatar,
        presentation: 'Davi Marcos é um carioca multiartista que vive na Maré, bairro do subúrbio do Rio de Janeiro. Atualmente, estuda licenciatura em Português-Literaturas na UFRJ. Fotógrafo que desenvolve suas obras com base na invisibilidade, memória e esquecimento gerados pela hierarquização do simbólico social.',
        audioPresentation: daviData.audio,
        photographies: [
            {
                name: 'Performances Cotidianas -Mudança no BRT ',
                photo: daviData.davi01
            },
            {
                name: 'Performances Cotidianas -Mudança no BRT ',
                photo: daviData.davi02,
            },
            {
                name: 'Performances Cotidianas -Mudança no BRT ',
                photo: daviData.davi03
            },
            {
                name: 'Performances Cotidianas -Mudança no BRT ',
                photo: daviData.davi04
            },
            {
                name: 'Performances Cotidianas -Mudança no BRT ',
                photo: daviData.davi05
            },
            {
                name: 'Performances Cotidianas -Mudança no BRT ',
                photo: daviData.davi06
            },
        ]
    },
    {
        id: 3,
        nome: 'Douglas Lopes',
        socialMedia: 'dougloppes',
        avatar: douglasData.avatar,
        presentation: `Fotógrafo, artista visual, diretor de fotografia, diretor criativo e videomaker, 30 anos, cria do Morro do Timbau, Maré. Participou de exposições como: 'Lab Criativo', no Galpão Bela Maré, em 2015; 'Literatura Exposta', mostra coletiva da Casa França Brasil, em 2018, que contou com obras de mais nove artistas e dez poetas de periferias do Rio de Janeiro, além de seu trabalho 'Biografias Imaginárias', uma produção fotográfica do poema 'Pretos' da Mc Martina. Fotógrafo da Lona Cultural da Maré de 2013 a 2017. Fotógrafo do Jornal Maré de Notícias de 2017 a 2020 e Fotógrafo e Videomaker da Redes da Maré de 2017 a 2021. Em 2020, assinou a direção de fotografia da série 'Marielle - o documentári'” para a Globoplay. Em 2021, assinou a fotografia e reportagem do vídeo 'Unifavela - Educação em tempos de pandemia' para o jornal online The Intercept Brasil. Também em 2021, assinou mais dois trabalhos: a fotografia do videoclipe 'E Você Diz' dos artistas Frejat, Jards Macalé e Luiz Melodia, e a direção de fotografia do documentário 'Vacina Maré'', em produção com estreia prevista ainda para o mesmo ano. Vive em constante pesquisa e estudos nos campos da fotografia e do audiovisual.`,
        audioPresentation: douglasData.audio,
        photographies: [
            {
                name: 'Conjunto de Favelas da Maré',
                photo: douglasData.douglas08
            },
            {
                name: 'Favela da Maré',
                photo: douglasData.douglas10
            },
            {
                name: 'Itaparica e Vera Cruz',
                photo: douglasData.douglas04
            },
            {
                name: 'Maria Aparecida',
                photo: douglasData.douglas07
            },
            {
                name: '',
                photo: douglasData.douglas01
            },
            {
                name: '',
                photo: douglasData.douglas02
            },
            {
                name: '',
                photo: douglasData.douglas03
            },
            {
                name: '',
                photo: douglasData.douglas05
            },
            {
                name: '',
                photo: douglasData.douglas09
            }
        ]
    },
    {
        id: 4,
        nome: 'Jones',
        socialMedia: 'hey__jones',
        avatar: jonesData.avatar,
        presentation: 'Jones é nascida e criada na Maré. Professora de educação física, arte educadora e artista visual. Tem na fotografia um encontro de si mesma de maneira a observar e refletir o cotidiano da favela como um encontro de suas origens, presentes em todos os lugares que ocupa. ',
        audioPresentation: jonesData.audio,
        photographies: [
            {
                name: '',
                photo: jonesData.jones01
            },
            {
                name: '',
                photo: jonesData.jones02
            },
            {
                name: '',
                photo: jonesData.jones03
            },
            {
                name: '',
                photo: jonesData.jones04
            },
            {
                name: '',
                photo: jonesData.jones05
            },
            {
                name: '',
                photo: jonesData.jones06
            },
            {
                name: '',
                photo: jonesData.jones07
            },
            {
                name: '',
                photo: jonesData.jones08
            },
            {
                name: '',
                photo: jonesData.jones09
            },
            {
                name: '',
                photo: jonesData.jones10
            },
            {
                name: '',
                photo: jonesData.jones11
            },
            {
                name: '',
                photo: jonesData.jones12
            },
            {
                name: '',
                photo: jonesData.jones13
            },
            {
                name: '',
                photo: jonesData.jones14
            },
            {
                name: '',
                photo: jonesData.jones15
            }
        ]
    },
    {
        id: 5,
        nome: 'Kamila Camillo',
        socialMedia: 'photokamilaa',
        avatar: kamilaData.avatar,
        presentation: `Kamila Camillo é moradora da Maré e começou a fotografar eventos na Igreja a partir dos 14 anos, quando registrava eventos católicos. Desde então, muitos processos atravessam sua trajetória, mas nunca parou de fotografar. Formada em Psicologia, frequentou também a Escola Popular de Comunicação Crítica – ESPOCC/Observatório de Favelas, a escola de Cinema Olhares da Maré / Redes da Maré e participou de projetos do coletivo de fotografia 'Imagens do Povo'. Sempre gostou de fotografar a Maré. Em 2018, fez uma série de fotografias de casais LGBTQIA+, e em homenagem ao mês das crianças fez também a série 'Crias do Tijolinho'. Participa do projeto Mulheres Gordas de Favelas, que nasce a partir de um olhar crítico perante estereótipos e estigmas sociais. O objetivo principal desse projeto é o empoderamento e a autoestima de corpos femininos gordos e favelados através do registro dos seus cotidianos através da fotografia. Em 2020, participou das coletivas 'Elã'' e 'Das Candongas'. Em 2021, participou da 'Corpo Morada', exposição idealizada pelo Observatório de Favelas - Maré.`,
        audioPresentation: kamilaData.audio,
        photographies: [
            {
                name: 'A arte de brincar 2',
                photo: kamilaData.kamila06
            },
            {
                name: 'A arte de brincar 3',
                photo: kamilaData.kamila07
            },
            {
                name: 'A arte de brincar 4',
                photo: kamilaData.kamila08
            },
            {
                name: 'A arte de brincar 5',
                photo: kamilaData.kamila09
            },
            {
                name: 'A arte do novo',
                photo: kamilaData.kamila10
            },
            {
                name: 'A arte do novo',
                photo: kamilaData.kamila11
            },
            {
                name: 'A arte do novo 2',
                photo: kamilaData.kamila13
            },
            {
                name: 'Arte de brincar',
                photo: kamilaData.kamila12
            },
            {
                name: 'Cotidiano favelado 6',
                photo: kamilaData.kamila01
            },
            {
                name: 'Cotidiano favelado 2',
                photo: kamilaData.kamila13
            },
            {
                name: 'Cotidiano favelado 3',
                photo: kamilaData.kamila14
            },
            {
                name: 'Cotidiano favelado 4',
                photo: kamilaData.kamila15
            },
            {
                name: 'Cotidiano favelado1',
                photo: kamilaData.kamila16
            },
            {
                name: 'Cotidiano favelado7',
                photo: kamilaData.kamila05
            }
        ]
    },
    {
        id: 6,
        nome: 'Kananda Ferreira',
        socialMedia: 'vishkaay',
        avatar: kanandaData.avatar,
        presentation: 'Meu nome é Kananda Ferreira e sou moradora de uma favela chamada Complexo da Maré, localizada no Rio de Janeiro / Brasil. Tenho 24 anos, sou escritora, educadora em formação (Licenciatura em Pedagogia na UERJ - Universidade do Estado do Rio de Janeiro), mãe e fotógrafa com o auxílio do meu celular. Através da fotografia, busco uma forma de me comunicar com as pessoas, de expressar o que sinto através das imagens e principalmente criar novas narrativas de humanização, dignidade e respeito sobre o lugar em que moro.',
        audioPresentation: kanandaData.audio,
        photographies: [
            {
                name: 'A produção das narrativas através do olhar',
                photo: kanandaData.kananda03
            },
            {
                name: 'Arte a céu aberto',
                photo: kanandaData.kananda16
            },
            {
                name: 'As raízes da infância favelada',
                photo: kanandaData.kananda01
            },
            {
                name: 'Cartografias_Insurgentes',
                photo: kanandaData.kananda12
            },
            {
                name: 'Cartografias_Insurgentes-2',
                photo: kanandaData.kananda14
            },
            {
                name: 'Cartografias_Insurgentes-3',
                photo: kanandaData.kananda10
            },
            {
                name: 'Cartografias_Insurgentes-4',
                photo: kanandaData.kananda14
            },
            {
                name: 'Cartografias_Insurgentes-5',
                photo: kanandaData.kananda11
            },
           
            {
                name: 'Construções e raízes',
                photo: kanandaData.kananda05
            },
            {
                name: 'Cotidiano nas ruas',
                photo: kanandaData.kananda06
            },
            {
                name: 'Festividades na favela',
                photo: kanandaData.kananda09
            },
            {
                name: 'Geometrias faveladas',
                photo: kanandaData.kananda04
            },
            {
                name: 'Outras perspectivas',
                photo: kanandaData.kananda03
            },
            {
                name: 'Simetrias e geometrias na Maré',
                photo: kanandaData.kananda08
            },

            {
                name: 'Verde esperança',
                photo: kanandaData.kananda07
            }
        ]
    },
    {
        id: 7,
        nome: 'Rosana Rodrigues',
        socialMedia: 'rosana.rodrigues_fotografia',
        avatar: rosanaData.avatar,
        presentation: 'Formada em 2012 pela Escola de Fotógrafos Populares, projeto criado pelo fotógrafo/documentarista João Roberto Ripper que deu origem à Escola Imagens do Povo, situada no Observatório de Favelas, localizado no bairro Maré, Rio de Janeiro. Graduada em Serviço Social pela UFRJ. Realiza documentações fotográficas sobre as atuais manifestações populares, sobre o cotidiano, favela, o cenário Rock, concertos de violões em espaços públicos, e atua como colaboradora fotográfica da Hi-Hat Girls Magazine, a qual é a primeira e única revista sobre mulheres bateristas da América Latina. A título de esclarecimento, a Hi-Hat Girls Magazine promove oficinas de bateria apenas para mulheres e meninas com o objetivo de incentivar habilidades musicais e contribuir para a igualdade de gênero na sociedade pelo viés da música.',
        audioPresentation: rosanaData.audio,
        photographies: [
            {
                name: 'Ato Não vai ter Golpe',
                photo:  rosanaData.rosana20
            },
            {
                name: 'Black Bloc',
                photo: rosanaData.rosana12
            },
            {
                name: 'Bloco de carnaval Carmelitas',
                photo: rosanaData.rosana13
            },
            {
                name: 'Bloco Lemy Ayò-Bloco Afro FEBARJ',
                photo: rosanaData.rosana22
            },
            {
                name: 'Detalhe Musical',
                photo: rosanaData.rosana14
            },
            {
                name: 'Dia internacional das Mulheres 8M-1',
                photo: rosanaData.rosana06
            },
            {
                name: 'Dia internacional da Mulheres 8M-2',
                photo: rosanaData.rosana07
            },
            {
                name: 'Dia internacional da Mulheres 8M-3',
                photo: rosanaData.rosana08
            },
            {
                name: 'Dia internacional das Mulheres 8M-4',
                photo: rosanaData.rosana09
            },
            {
                name: 'Dia internacional de luta das mulheres 8M',
                photo: rosanaData.rosana11
            },
            {
                name: 'Dia Internacional de Luta das Mulheres',
                photo: rosanaData.rosana10
            },
            {
                name: 'Ela e o Violão',
                photo: rosanaData.rosana15
            },
            {
                name: 'Manifestação dos Professores',
                photo: rosanaData.rosana16
            },
            {
                name: 'Marcha Basta de violência - Outra Maré é possível',
                photo: rosanaData.rosana17
            },
            {
                name: 'Mulheres Unidas contra Bolsonaro -1',
                photo: rosanaData.rosana18
            },
            {
                name: 'Mulheres Unidas contra Bolsonaro-2',
                photo: rosanaData.rosana19
            },
            {
                name: 'Outra Maré_é possível',
                photo: rosanaData.rosana01
            },
            {
                name: 'A Maré é Complexo',
                photo: rosanaData.rosana23
            },
            {
                name: 'Ato Abraço CIEP Operário Vicente Mariano',
                photo: rosanaData.rosana02
            },
            {
                name: 'Ato Abraço CIEP Operário Vicente Mariano 2',
                photo: rosanaData.rosana03
            },
            {
                name: 'Dona_Vera_Mulher_guerreira',
                photo: rosanaData.rosana04
            },
            {
                name: 'Grito dos excluídos',
                photo: rosanaData.rosana05
            },

        ]
    },
]

export default artists